import { render, staticRenderFns } from "./WeightAndShipping.vue?vue&type=template&id=6ba0a56e&"
import script from "./WeightAndShipping.vue?vue&type=script&lang=js&"
export * from "./WeightAndShipping.vue?vue&type=script&lang=js&"
import style0 from "./WeightAndShipping.vue?vue&type=style&index=0&id=6ba0a56e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports